<template>
  <MetricTotal
    :title="title"
    :item-id="itemId"
    :metric="metric"
    :owner-posts="true"
    :info-title="$t('library.SAC_5.info.title')"
    :info-paragraphs="infoParagraphs"
    v-bind="$attrs"
  />
</template>

<script>
import MetricTotal from '@/components/cards/MetricTotal';
import { POST_FIELDS } from '@/services/charts-service';
import proprietaryModel from '@/mixins/proprietary-model';

export default {
  name: 'PropCommentsTotal',
  components: {
    MetricTotal,
  },
  mixins: [
    proprietaryModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    metric() {
      return POST_FIELDS.COMMENTS;
    },
    infoParagraphs() {
      return ['intro', 'type', 'status', 'compare'].map(key => this.$t(`library.SAC_5.info.${key}`));
    },
  },
};
</script>
